<div
  #sectionItem
  class="expanded-product-info-item-product-container"
  id="product-container-m{{ menu.id }}-s{{ sectionIndex }}-i{{ itemIndex }}"
  [ngClass]="[
    rowViewModel | sectionRowViewModelBasicMethod: 'getReadableStrainType' | lowercase,
    menu | productMenuBasicMethod: 'getProductWrapperClass' : odd
  ]"
  [class.odd]="odd"
  [class.even]="!odd"
  [class.first]="first"
  [class.last]="last"
  [class.force-bold-style]="viewModel.forcedRowBoldStyling$ | async"
  [class.force-italic-style]="viewModel.forcedRowItalicStyling$ | async"
  [class.has-background-color]="viewModel.rowBackgroundColor$ | async | getArrayElementAtIndex: 1"
  [ngStyle]="viewModel.productWrappingStyle$ | async"
  [style.background-color]="viewModel.rowBackgroundColor$ | async | getArrayElementAtIndex: 1"
  [style.color]="viewModel.forcedRowTextColorToDisplay$ | async"
  [style.text-decoration-color]="viewModel.forcedRowTextColor$ | async"
  [style.zoom]="viewModel.forcedRowZoom$ | async"
  [style.border-color]="viewModel.sectionBorderColor$ | async">
  <div class="expanded-product-info-item-product-asset-wrapper">
    <ng-container
      *rxFor="let colVm of viewModel.columnViewModels$; trackBy: trackByColViewModelId; strategy: 'immediate'">
      <app-column-asset
        *ngIf="colVm.columnType === Types.SectionColumnProductInfoType.Asset"
        [menu]="menu"
        [section]="section"
        [colVm]="colVm"
        [rowVm]="rowViewModel"
        [locConfig]="locationConfig"
        [locationId]="locationId"
        [productStylingVm]="viewModel"
        [reset]="reset">
      </app-column-asset>
    </ng-container>
  </div>
  <div class="expanded-product-info-item-product-content-wrapper">
    <div class="expanded-product-info-item-product-brand-and-title">
      <div class="expanded-product-info-item-product-title">
        {{ rowViewModel | sectionRowViewModelBasicMethod: 'getRowTitle' }}
      </div>
      <div class="expanded-product-info-item-product-brand">
        {{ rowViewModel | sectionRowViewModelBasicMethod: 'getBrand' }}
      </div>
    </div>
    <div class="expanded-product-info-item-inner-wrapper">
      <div class="expanded-product-info-item-left-side">
        <div class="expanded-product-info-item-badge-and-label">
          <ng-container *ngIf="rowViewModel | allVariantBadges as badges">
            <div *ngIf="badges?.length > 0" class="expanded-product-info-item-product-badge">
              <div
                *ngFor="let b of badges; trackBy: trackByBadgeUniqueIdentifier"
                class="expanded-product-info-item-badge">
                <img
                  appImage
                  [style.height]="'100%'"
                  [style.width]="'100%'"
                  [asset]="b.image"
                  [reset]="reset"
                  alt="badge"
                  src="" />
              </div>
            </div>
          </ng-container>

          <app-label-inflator
            #labelInflator
            *ngIf="!calculationMode && viewModel.showLabelInLabelColumn$ | async"
            class="expanded-product-info-item-product-label-container"
            [columnLabel]="true"
            [labelComponentInterface]="rowViewModel">
          </app-label-inflator>
        </div>
        <div *ngIf="viewModel.hasCannabinoidProperties$ | async" class="expanded-product-info-item-cannabinoids">
          <div *rxFor="let data of viewModel.cannabinoidPropertiesBasedOnPools$; strategy: 'immediate'">
            <div>{{ data.title }} {{ data.value }}</div>
          </div>
        </div>
        <div *ngIf="viewModel.hasTerpeneProperties$ | async" class="expanded-product-info-item-terpenes">
          <div *rxFor="let data of viewModel.terpenePropertiesBasedOnPools$; strategy: 'immediate'">
            <div>{{ data.title }} {{ data.value }}</div>
          </div>
        </div>
        <div *ngIf="viewModel.showTerpsAndTopTerpene$ | async" class="expanded-product-info-item-terps-and-top-terpene">
          <div class="expanded-product-info-item-terps">TERPS {{ viewModel.totalAccumulatedTerpenes$ | async }}</div>
          <div class="expanded-product-info-item-top-terpene">{{ viewModel.topTerpene$ | async }}</div>
        </div>
      </div>
      <div class="expanded-product-info-item-right-side">
        <div class="expanded-product-info-item-type-and-size">
          <div class="expanded-product-info-item-product-variant-type">
            {{ rowViewModel | sectionRowViewModelBasicMethod: 'rowVariantType' }}
          </div>
          <div class="expanded-product-info-item-product-size">
            {{
              viewModel
                | getProductSectionItemExpandedProductInfoExpandedGridSize
                  : (rowViewModel?.rowVariants | getArrayItemAt: 0)
                | async
            }}
          </div>
        </div>
        <div class="expanded-product-info-item-price">
          <ng-container
            *rxFor="let colVm of viewModel.columnViewModels$; trackBy: trackByColViewModelId; strategy: 'immediate'">
            <app-column-primary-price
              *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.VariantPrice"
              [menu]="menu"
              [section]="section"
              [colVm]="colVm"
              [rowVm]="rowViewModel"
              [locConfig]="locationConfig"
              [locationId]="locationId"
              [productStylingVm]="viewModel">
            </app-column-primary-price>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
